import { useContext } from 'react';

// auth provider
import SessionContext from 'contexts/SessionContext';

// ==============================|| PERMISSIONS HOOK ||============================== //

export default function usePermissions() {
  const context = useContext(SessionContext);

  if (!context) throw new Error('usePermissions must be used inside SessionProvider');

  const { user, permissions } = context;

  // Helper function to check if user has permission for a specific module
  const hasPermission = (module, requiredPermission = 10) => {
    if (!user || !permissions) return false;
    
    const userPermission = permissions[module];
    if (userPermission === undefined || userPermission === null) return false;
    
    // Check if user has at least the required permission level
    return userPermission >= requiredPermission;
  };

  // Helper function to check specific permission levels
  const canView = (module) => hasPermission(module, 10);
  const canEdit = (module) => hasPermission(module, 20);
  const canFull = (module) => hasPermission(module, 30);

  return {
    permissions,
    hasPermission,
    canView,
    canEdit,
    canFull,
    user
  };
}
